import { createSelector } from "reselect";
import moment from "moment";
import "moment/locale/es";
import { ROLES_RAW } from "../../constants/permissions";
moment().locale("es");

/* APP */
export const isUserAuthorized = createSelector(
  (state) => state.authorization,
  (authorization) => authorization
);
export const getCurrentRoute = createSelector(
  (state) => state.currentRoute,
  (currentRoute) => currentRoute
);
export const getCurrentRouteTitle = createSelector(
  getCurrentRoute,
  (route) => route.title
);
export const getSideMenuState = createSelector(
  (state) => state.app,
  (app) => app.isCollapsedSideMenu
);
export const getCurrentTheme = createSelector(
  (state) => state.currentTheme,
  (currentTheme) => currentTheme
);

/* PROFILE */
export const getUserProfile = createSelector(
  (state) => state.profile,
  (profile) => profile
);
export const currentUserId = createSelector(
  (state) => state.profile,
  (profile) => profile && profile.id
);
export const getCurrentUserRole = createSelector(getUserProfile, (profile) =>
  !profile ? null : (ROLES_RAW.includes(profile.role) ? profile.role : null)
);

/* NOTIFICATIONS STATE */
export const getNotificationsState = createSelector(
  (state) => state.notifications,
  (notifications) => notifications
);

/* USERS */
export const getUsers = createSelector(
  (state) => state.users,
  (users) => users
);
export const getUsersForm = createSelector(
  (state) => state.usersForm,
  (form) => form
);

/* ROLES */
export const getRoles = createSelector(
  (state) => state.roles,
  (roles) => roles
);
export const getRolesForm = createSelector(
  (state) => state.rolesForm,
  (form) => form
);

/* ALERT */
export const getAlerts = createSelector(
  (state) => state.alerts,
  (alerts) => alerts
);
export const getAlertsForm = createSelector(
  (state) => state.alertsForm,
  (form) => form
);

/* ZONES */
export const getZones = createSelector(
    (state) => state.zones,
    (zones) => zones
);
export const getZonesForm = createSelector(
    (state) => state.zonesForm,
    (form) => form
);

/* CONTAINERS */
export const getContainers = createSelector(
    (state) => state.containers,
    (containers) => containers
);
export const getContainersForm = createSelector(
    (state) => state.containersForm,
    (form) => form
);

/* CONTAINERMEASUREMENTS */
export const getContainermeasurements = createSelector(
    (state) => state.containermeasurements,
    (containermeasurements) => containermeasurements
);
export const getContainermeasurementsForm = createSelector(
    (state) => state.containermeasurementsForm,
    (form) => form
);

/* HOTELDATA */
export const getHoteldatas = createSelector(
    (state) => state.hoteldatas,
    (hoteldatas) => hoteldatas
);
export const getHoteldatasForm = createSelector(
    (state) => state.hoteldatasForm,
    (form) => form
);

/* HOTELCHAINS */
export const getHotelchains = createSelector(
    (state) => state.hotelchains,
    (hotelchains) => hotelchains
);
export const getHotelchainsForm = createSelector(
    (state) => state.hotelchainsForm,
    (form) => form
);

/* ESTABLISHMENTS */
export const getEstablishments = createSelector(
    (state) => state.establishments,
    (establishments) => establishments
);
export const getEstablishmentsForm = createSelector(
    (state) => state.establishmentsForm,
    (form) => form
);

/* WASTETYPES */
export const getWastetypes = createSelector(
    (state) => state.wastetypes,
    (wastetypes) => wastetypes
);
export const getWastetypesForm = createSelector(
    (state) => state.wastetypesForm,
    (form) => form
);

/* ZONECATEGORIES */
export const getZonecategories = createSelector(
    (state) => state.zonecategories,
    (zonecategories) => zonecategories
);
export const getZonecategoriesForm = createSelector(
    (state) => state.zonecategoriesForm,
    (form) => form
);

/* SUPPORTS */
export const getSupports = createSelector(
    (state) => state.supports,
    (supports) => supports
);
export const getSupportsForm = createSelector(
    (state) => state.supportsForm,
    (form) => form
);
